import _Field from "redux-form/es/Field";
import React from 'react';
import UnderlinedInput from 'swag-client-common/components/inputs/underlined-input';
import { email, required, mailDomain as mailDomainValidator } from 'swag-client-common/utils/redux-form-validators';
import classes from './email-field.scss';
export default function EmailField(props) {
  const {
    isMailDomainPredefined,
    mailDomain
  } = props;
  const mailDomainHint = isMailDomainPredefined ? ` (example: johndoe@${mailDomain})` : '';
  const validators = [required, email];
  if (isMailDomainPredefined) {
    // eslint-disable-next-line no-console
    console.log('pushed', mailDomain);
    validators.push(mailDomainValidator(mailDomain));
  }
  return /*#__PURE__*/React.createElement(_Field, {
    dataInput: "Email",
    name: "email",
    component: UnderlinedInput,
    type: "text",
    validate: validators,
    label: `Your email${mailDomainHint}`,
    className: classes.classNameInput
  });
}